module.exports = __webpack_public_path__ + "img/fuzzcv-logo.c7b4ccee.webp";